<template>
    <div>
        <div class="table w-full">
            <div class="table-cell w-1 align-middle">
                <slot name="search"></slot>
            </div>
            <div class="table-cell">
                <div class="table w-full">
                    <div class="table-cell">
                        <div class="table w-full bg-white border rounded my-1">
                            <div class="table-cell w-1 align-middle">
                                <div class="sprite-icons-search bg-white"></div>
                            </div>
                            <div class="table-cell align-middle">
                                <input class="text-lg p-2 flex-1 outline-none bg-white w-full" :value="search"
                                       @input="$emit('update:search', $event.srcElement.value)"
                                       @keydown.enter="refresh()"/>
                            </div>
                            <div class="table-cell w-1 align-middle">
                                <div class="btn btn-primary" @click="refresh()">Search</div>
                            </div>
                            <div class="table-cell w-1 align-middle">
                                <div class="btn bg-excel" @click="downloadExcel()">Excel</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <m-table ref="table" :refresh="refreshData" :args="args" @click="p => $emit('click', p)" :initial="initial">
            <template slot="header">
                <slot name="header"></slot>
            </template>
            <template v-slot="{row, index}">
                <slot :row="row" :index="index"></slot>
            </template>
        </m-table>
    </div>
</template>
<script>
import Ajax from '@/js/ajax.js'

export default {
    props: {
        search: String,
        url: String,
        args: {
            type: Object,
            default: {}
        },
        filter: Function,
        interceptor: Function,
        initial: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        downloadExcel() {
            Ajax.download(`/querytable/${this.url}/excel`, this.args)
        },
        refresh() {
            // let the parent know that arguments has changed
            // the parent will then in turn call refresh
            this.$emit('search');
        },
        refreshTable() {
            this.$refs.table.refreshData();
        },
        refreshData(page, rows, args) {
            return Ajax.post(`/querytable/${this.url}/query`, {
                page: page,
                rowsPerPage: rows,
                ...args
            }, false).then(resp => {
                // Intercept the whole response
                // Sometimes response is not pagenation response
                resp = this.interceptor ? this.interceptor(resp) : resp
                var data = {
                    count: resp.total,
                    data: this.filter ? this.filter(resp.items) : resp.items
                }
                return data
            })
        }
    }
};
</script>
